import { Filter } from '@witkac/kartamiejska-shared';
import { tryParseBoolean } from '@witkac/utils/tryParseBoolean';
import { tryParseInt } from '@witkac/utils/tryParseInt';
import { Route } from 'vue-router';

/**
 * Bazowe filtry na podstawie query
 *
 * @export
 * @param {Route} route
 * @returns {Filter}
 */
export function baseFilters(route: Route): Filter {
  const filters: Filter = {};

  filters.count = tryParseInt(route.query.count) || 10;

  if (route.query.search) {
    filters.search = route.query.search as string;
  }

  if (route.query.page) {
    const page = (tryParseInt(route.query.page) as number) - 1;
    filters.start = page * filters.count;
  }

  if (route.query.order) {
    filters.order = route.query.order as string;
    filters.desc = tryParseBoolean(route.query.desc);
  }

  if (route.query.orderBy && route.query.orderBy.length) {
    const desc = tryParseBoolean(route.query.desc);
    filters.orderBy = (route.query.orderBy as string[]).map(name => ({ name, desc }));
  }

  return filters;
}
